import { render } from "./specialBooks.vue?vue&type=template&id=2e03f47c&scoped=true"
import script from "./specialBooks.vue?vue&type=script&lang=js"
export * from "./specialBooks.vue?vue&type=script&lang=js"

import "./specialBooks.vue?vue&type=style&index=0&id=2e03f47c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e03f47c"]])

export default __exports__